var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C3.81 0 0 3.81 0 8.5C0 13.19 3.81 17 8.5 17H9V20C13.86 17.66 17 13 17 8.5C17 3.81 13.19 0 8.5 0ZM9.5 14.5H7.5V12.5H9.5V14.5ZM9.9 9.72C9.89 9.73 9.88 9.75 9.87 9.77C9.82 9.85 9.77 9.93 9.73 10.01C9.71 10.04 9.7 10.08 9.69 10.12C9.66 10.19 9.63 10.26 9.61 10.33C9.54 10.54 9.51 10.76 9.51 11.01H7.5C7.5 10.5 7.58 10.07 7.7 9.71C7.7 9.7 7.7 9.69 7.71 9.68C7.72 9.64 7.75 9.62 7.76 9.58C7.82 9.42 7.89 9.28 7.98 9.14C8.01 9.09 8.05 9.04 8.08 8.99C8.11 8.95 8.13 8.9 8.16 8.87L8.17 8.88C9.01 7.78 10.38 7.44 10.49 6.2C10.58 5.22 9.88 4.27 8.92 4.07C7.88 3.85 6.94 4.46 6.62 5.35C6.48 5.71 6.15 6 5.74 6H5.54C4.94 6 4.5 5.41 4.67 4.83C4.9502 3.91042 5.55206 3.12243 6.3655 2.61013C7.17894 2.09783 8.14961 1.89545 9.1 2.04C10.79 2.29 12.14 3.68 12.43 5.37C12.87 7.81 10.8 8.4 9.9 9.72Z",
    fill: "#818181"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.f1b35ff9394115505e2d7713dbb84cd0.svg";
export { ForwardRef as ReactComponent };